import React from 'react';
import moment from 'moment';
import { Box } from '@material-ui/core';

const DateRenderer = ({
  value
}: any) => <Box>{value ? moment(value).format('ll') : <span>&mdash;</span>}</Box>;

export default DateRenderer;
